import React from 'react';
import { View } from 'react-native';
import Text from 'app/components/Text';
import { StyleContext } from 'app/contexts/Style';

// size: 'tiny' | 'small' | 'medium'
export default class TarotCard extends React.Component {
  static contextType = StyleContext;

  render() {
    const { card, size = 'small', incomplete = false } = this.props;
    if (!card) return null;

    const dim = size === 'tiny' ? 14 : size === 'medium' ? 36 : 22;
    const fontSize = size === 'tiny' ? 9 : size === 'medium' ? 16 : 12;

    if (card.type === 'major') {
      return (
        <View style={{
          width: dim,
          height: dim,
          borderRadius: dim / 2,
          backgroundColor: incomplete ? 'transparent' : '#fff',
          borderWidth: incomplete ? 2 : 0,
          borderColor: '#fff',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: card.reversed ? 0.6 : 1,
        }}>
          <Text style={{ fontSize: dim * 0.65, lineHeight: dim }}>{card.emoji}</Text>
        </View>
      );
    }

    // minor arcana
    const { color, symbol } = card;
    if (!color || !symbol) return null;

    return (
      <View style={{
        width: dim,
        height: dim,
        borderRadius: dim / 2,
        backgroundColor: incomplete ? 'transparent' : color,
        borderWidth: incomplete ? 2 : 0,
        borderColor: color,
        alignItems: 'center',
        justifyContent: 'center',
        opacity: card.reversed ? 0.6 : 1,
      }}>
        <Text style={{
          fontSize,
          color: incomplete ? color : '#fff',
          fontWeight: '700',
          lineHeight: dim,
          textAlign: 'center',
        }}>
          {symbol}
        </Text>
      </View>
    );
  }
}
